import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, requiredRole, forbiddenRoles }) {
  const token = localStorage.getItem('authToken');
  const role = localStorage.getItem('role');

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // If route requires specific role (case-insensitive)
  if (requiredRole && role?.toLowerCase() !== requiredRole?.toLowerCase()) {
    return <Navigate to={role?.toLowerCase() === 'admin' ? '/admin-dashboard' : '/dashboard'} replace />;
  }

  // If route forbids certain roles (case-insensitive)
  if (forbiddenRoles?.some(forbidden => role?.toLowerCase() === forbidden.toLowerCase())) {
    return <Navigate to={role?.toLowerCase() === 'admin' ? '/admin-dashboard' : '/dashboard'} replace />;
  }

  return children;
}
